import axios from '../../../lib/axios';

export const getPrivacyConsentByUserId = async () => {
    let url = `/api/classroom/userAcceptedDataTreatment`;
    try {
        await axios.get(url);
    } catch (e) {
        if (e.message === 'Request aborted') {
            throw new Error('Request aborted');
        }

        return false;
    }

    return true;
};

export const getStatusByAssigmentIdAndStudentIdIn = async (assignmentId, studentId) => {
    let url = `/api/status/teacher/assignment/${assignmentId}?studentIds=${studentId}`;
    try {
        let statusList = await axios.get(url);
        let data = statusList?.data;

        if (statusList && Array.isArray(data)) {
            if (data.length === 0) {
                return data;
            }
            data.sort((a, b) => b.modificationTime - a.modificationTime);

            const mostRecentStatus = data.pop();
            return mostRecentStatus;
        }
    } catch (e) {
        if (e.message === 'Request aborted') {
            throw new Error('Request aborted');
        }
    }
};

export const setPrivacyConsentByUserId = async () => {
    let url = `/api/classroom/userAcceptedDataTreatment`;
    try {
        await axios.post(url);
    } catch {
        return false;
    }

    return true;
};
